module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/other-kp/component/other-kp-detail/other-kp-main-modal-popup-customer/other-kp-main-modal-popup-customer.component.sass
// module id = ./src/app/modules/other-kp/component/other-kp-detail/other-kp-main-modal-popup-customer/other-kp-main-modal-popup-customer.component.sass
// module chunks = main